import { Typography } from "@mui/material";

const Footer = ({ ...props }) => {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      © {new Date().getFullYear()} Ajifarms. All rights reserved.
    </Typography>
  );
};

export default Footer;
